// extracted by mini-css-extract-plugin
export default {"business_Appoint":"BusinessAppointments_business_Appoint__09YVq","business_Appoint_List":"BusinessAppointments_business_Appoint_List__7d2UD"};